(function () {
  var storageKey = 'emhues:wishlist';
  var legacyKey = 'emhues_wishlist';

  function readWishlist() {
    var raw = window.localStorage.getItem(storageKey) || window.localStorage.getItem(legacyKey);
    if (!raw) return [];

    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(function (item) {
          if (typeof item === 'string') return { handle: item };
          return item && item.handle ? item : null;
        })
        .filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    var seen = {};
    var cleanItems = items.filter(function (item) {
      if (!item || !item.handle || seen[item.handle]) return false;
      seen[item.handle] = true;
      return true;
    });

    window.localStorage.setItem(storageKey, JSON.stringify(cleanItems));
    window.localStorage.removeItem(legacyKey);
    window.dispatchEvent(new CustomEvent('emhues:wishlist:change', { detail: { items: cleanItems } }));
    return cleanItems;
  }

  function findItem(handle) {
    return readWishlist().find(function (item) {
      return item.handle === handle;
    });
  }

  function buttonProduct(button) {
    return {
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || (button.dataset.productHandle ? '/products/' + button.dataset.productHandle : ''),
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || ''
    };
  }

  function updateButtons() {
    var items = readWishlist();
    var handles = items.map(function (item) { return item.handle; });

    document.querySelectorAll('[data-wishlist-button]').forEach(function (button) {
      var handle = button.dataset.productHandle;
      var active = handles.indexOf(handle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (count) {
      count.textContent = items.length;
      count.hidden = items.length === 0;
    });
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR',
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (error) {
      return 'Rs. ' + amount.toFixed(2);
    }
  }

  function productCard(product) {
    var image = product.featured_image || product.image || '';
    var compare = Number(product.compare_at_price || 0);
    var price = Number(product.price || 0);
    var isSale = compare > price;
    var firstVariant = product.variants && product.variants[0];
    var canBuySingle = product.available && product.variants && product.variants.length === 1 && firstVariant;

    return [
      '<article class="emhues-wishlist-card" data-wishlist-card="' + product.handle + '">',
        '<a class="emhues-wishlist-card__media" href="' + product.url + '">',
          image ? '<img src="' + image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '',
          isSale ? '<span class="emhues-wishlist-card__badge">Sale</span>' : '',
        '</a>',
        '<div class="emhues-wishlist-card__info">',
          product.vendor ? '<p class="emhues-wishlist-card__vendor">' + escapeHtml(product.vendor) + '</p>' : '',
          '<h2><a href="' + product.url + '">' + escapeHtml(product.title) + '</a></h2>',
          '<p class="emhues-wishlist-card__price">',
            isSale ? '<s>' + formatMoney(compare) + '</s>' : '',
            '<span class="' + (isSale ? 'is-sale' : '') + '">' + formatMoney(price) + '</span>',
          '</p>',
          '<div class="emhues-wishlist-card__actions">',
            canBuySingle
              ? '<button class="button button--primary" type="button" data-wishlist-add-cart data-variant-id="' + firstVariant.id + '">Add to cart</button>'
              : '<a class="button button--primary" href="' + product.url + '">Choose options</a>',
            '<button class="button button--secondary" type="button" data-wishlist-remove="' + product.handle + '">Remove</button>',
          '</div>',
        '</div>',
      '</article>'
    ].join('');
  }

  function fallbackCard(item) {
    return [
      '<article class="emhues-wishlist-card" data-wishlist-card="' + item.handle + '">',
        '<a class="emhues-wishlist-card__media" href="' + (item.url || '/products/' + item.handle) + '">',
          item.image ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title || item.handle) + '" loading="lazy">' : '',
        '</a>',
        '<div class="emhues-wishlist-card__info">',
          '<h2><a href="' + (item.url || '/products/' + item.handle) + '">' + escapeHtml(item.title || item.handle) + '</a></h2>',
          item.price ? '<p class="emhues-wishlist-card__price"><span>' + escapeHtml(item.price) + '</span></p>' : '',
          '<div class="emhues-wishlist-card__actions">',
            '<a class="button button--primary" href="' + (item.url || '/products/' + item.handle) + '">View product</a>',
            '<button class="button button--secondary" type="button" data-wishlist-remove="' + item.handle + '">Remove</button>',
          '</div>',
        '</div>',
      '</article>'
    ].join('');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function renderWishlistPage() {
    var root = document.querySelector('[data-wishlist-page]');
    if (!root) return;

    var grid = root.querySelector('[data-wishlist-grid]');
    var empty = root.querySelector('[data-wishlist-empty]');
    var loading = root.querySelector('[data-wishlist-loading]');
    var items = readWishlist();

    if (!grid || !empty || !loading) return;

    empty.hidden = items.length !== 0;
    grid.hidden = true;
    loading.hidden = items.length === 0;
    grid.innerHTML = '';

    if (!items.length) return;

    Promise.all(items.map(function (item) {
      return fetch('/products/' + encodeURIComponent(item.handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Product unavailable');
          return response.json();
        })
        .then(function (product) {
          product.url = product.url || '/products/' + product.handle;
          return productCard(product);
        })
        .catch(function () {
          return fallbackCard(item);
        });
    })).then(function (cards) {
      grid.innerHTML = cards.join('');
      grid.hidden = false;
      loading.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var wishlistButton = event.target.closest('[data-wishlist-button]');
    if (wishlistButton) {
      var product = buttonProduct(wishlistButton);
      if (!product.handle) return;

      var items = readWishlist();
      if (findItem(product.handle)) {
        items = items.filter(function (item) { return item.handle !== product.handle; });
      } else {
        items.unshift(product);
      }
      writeWishlist(items);
      updateButtons();
      renderWishlistPage();
      return;
    }

    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      var handle = removeButton.dataset.wishlistRemove;
      writeWishlist(readWishlist().filter(function (item) { return item.handle !== handle; }));
      updateButtons();
      renderWishlistPage();
      return;
    }

    var addCartButton = event.target.closest('[data-wishlist-add-cart]');
    if (addCartButton) {
      addCartButton.disabled = true;
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: addCartButton.dataset.variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          addCartButton.textContent = 'Added';
        })
        .catch(function () {
          addCartButton.disabled = false;
          addCartButton.textContent = 'Try again';
        });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateButtons();
    renderWishlistPage();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey || event.key === legacyKey) {
      updateButtons();
      renderWishlistPage();
    }
  });

  window.addEventListener('emhues:wishlist:change', updateButtons);
})();
